import React from "react";

// Public child safety standards page (reachable without an account). Google
// Play requires a publicly available child safety standards URL; the URL
// registered with Google Play is /child-safety.html, and App.js renders this
// page at that exact path (plus /child-safety as an alias). The text mirrors
// Terms of Service §3.6 — update both together.
export default function ChildSafety() {
  return (
    <main className="legalPage">
      <div className="legalPage__inner">
        <h1 className="legalPage__title">Child Safety Standards</h1>
        <p className="legalPage__lead">
          BetterIntentions, operated by BetterIntentions, LLC. These standards
          form part of our <a href="/terms-of-service">Terms of Service</a>{" "}
          (Section 3.6, "Child Safety and Zero Tolerance for Child Sexual
          Abuse and Exploitation (CSAE)") and are published here as a
          standalone public page.
        </p>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">
            Child Safety and Zero Tolerance for Child Sexual Abuse and
            Exploitation (CSAE)
          </h2>
          <div className="legalPage__sectionContent">
            <p>
              The Platform is intended for users aged 16 and older. Chat is
              text-based only — users may not send photographs, videos, or
              other images in messages; the only image you may upload is an
              optional profile photo, which is automatically screened by an
              image-moderation service. We have zero tolerance for child
              sexual abuse and exploitation (CSAE) and for any content or
              conduct that sexualizes, endangers, or exploits a minor. The
              following standards apply to every user, form part of our
              publicly available terms, and supplement the prohibited conduct
              described in Section 3.3 of our Terms of Service.
            </p>
          </div>
        </section>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">
            Prohibited child safety conduct
          </h2>
          <div className="legalPage__sectionContent">
            <p>
              You may not use the Platform to create, post, store, request,
              solicit, share, promote, facilitate access to, or otherwise
              engage in child sexual abuse material (CSAM) or any other form
              of CSAE. This includes the grooming, enticement, sextortion,
              sexualization, or trafficking of any person under the age of 18,
              and any attempt to use the Platform to identify, contact, or
              arrange contact with a minor for any such purpose. This
              prohibition applies regardless of whether the minor involved is
              real, fictional, or computer-generated.
            </p>
          </div>
        </section>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">
            How to report child safety concerns in the app
          </h2>
          <div className="legalPage__sectionContent">
            <p>
              The Platform provides an in-app mechanism that allows you to
              submit feedback, concerns, or reports, including the "Report"
              and "Block" options available within each conversation and on
              each user profile. If you encounter content or conduct that may
              violate these child safety standards, you must report it
              immediately using these in-app tools or by contacting our Child
              Safety Point of Contact identified below. Reports of suspected
              CSAE are prioritized for review.
            </p>
          </div>
        </section>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">
            Our enforcement and removal actions
          </h2>
          <div className="legalPage__sectionContent">
            <p>
              Upon obtaining actual knowledge of CSAM or other CSAE on the
              Platform, we will take appropriate action in accordance with our
              Terms of Service and applicable law. Such action may include
              removing the offending content, preserving relevant records as
              required or permitted by law, suspending or permanently
              terminating the responsible account(s), and reporting the matter
              to law enforcement or other appropriate authorities.
            </p>
          </div>
        </section>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">
            Compliance with child safety laws; NCMEC reporting
          </h2>
          <div className="legalPage__sectionContent">
            <p>
              We comply with applicable child safety laws and regulations. We
              maintain a process to report apparent or confirmed CSAM to the
              National Center for Missing &amp; Exploited Children (NCMEC)
              through its CyberTipline at{" "}
              <a
                href="https://www.cybertipline.org"
                target="_blank"
                rel="noreferrer noopener"
              >
                www.cybertipline.org
              </a>{" "}
              or, where applicable, to the relevant authority in the user's
              jurisdiction, as required by law.
            </p>
          </div>
        </section>

        <section className="legalPage__section">
          <h2 className="legalPage__sectionTitle">
            Child Safety Point of Contact
          </h2>
          <div className="legalPage__sectionContent">
            <p>
              We have designated a Child Safety Point of Contact to receive
              notifications, including from Google Play, regarding potential
              child sexual abuse and exploitation (CSAE) content found in our
              app or on the Platform. This representative is positioned to
              speak to our enforcement and review procedures and to take
              action where required:
            </p>
            <address style={{ fontStyle: "normal", whiteSpace: "pre-line" }}>
              Child Safety Point of Contact: Matthew L. Grabinski{"\n"}
              Email:{" "}
              <a href="mailto:matt@betterintentions.com">
                matt@betterintentions.com
              </a>
              {"\n"}
              Address:{"\n"}
              BetterIntentions, LLC{"\n"}
              2388 Immokalee Rd., #277{"\n"}
              Naples, FL 34110
            </address>
          </div>
        </section>
      </div>
    </main>
  );
}
